const formatStamp = (value) => {
  if (!value) return "Not yet";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "Pending";
  return parsed.toLocaleString("en-SG", {
    day: "2-digit",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const buildTimeline = (ambassador) => {
  const items = [];
  if (ambassador.invitation_created_at) {
    items.push({ label: "Link ready", value: ambassador.invitation_created_at, testId: `admin-ambassador-invite-ready-${ambassador.slug}` });
  }
  if (ambassador.invitation_first_opened_at) {
    items.push({ label: "First open", value: ambassador.invitation_first_opened_at, testId: `admin-ambassador-first-open-${ambassador.slug}` });
  }
  if (ambassador.invitation_last_opened_at) {
    items.push({ label: `Last open • ${ambassador.invitation_open_count || 0} total`, value: ambassador.invitation_last_opened_at, testId: `admin-ambassador-last-open-${ambassador.slug}` });
  }
  return items;
};

const statusToneMap = {
  "Pending Invite": "bg-[#fff3da] text-[#8B6E3D]",
  "Claim Pending": "bg-[#FDECEC] text-[#A34A42]",
  "Checkout Pending": "bg-[#EAF2FF] text-[#325683]",
  "Active Agent": "bg-[#E8F6EC] text-[#2F7A49]",
  "Showroom Ready": "bg-[#EAF2FF] text-[#325683]",
  "Public Live": "bg-[#E8F6EC] text-[#2F7A49]",
};

export const AmbassadorRolloutMonitor = ({ ambassadors = [] }) => {
  const activeStatuses = new Set(["Active Agent", "Public Live"]);
  const pendingCount = ambassadors.filter((item) => !activeStatuses.has(item.status_label)).length;
  const activeCount = ambassadors.filter((item) => activeStatuses.has(item.status_label)).length;

  return (
    <div className="rounded-[28px] border border-[#001935]/10 bg-[#FDFBF7] p-6 shadow-[0_24px_70px_rgba(0,25,53,0.08)]" data-testid="admin-ambassador-rollout-monitor">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#8b6d16]">Master Admin • Ambassador Monitor</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-[#001935]">First-logins and unlock status for the launch five.</h2>
        </div>
        <div className="flex flex-wrap gap-3">
          <div className="rounded-full border border-[#001935]/10 bg-white px-4 py-2 text-sm font-semibold text-[#001935]" data-testid="admin-ambassador-pending-count">Pending {pendingCount}</div>
          <div className="rounded-full border border-[#001935]/10 bg-white px-4 py-2 text-sm font-semibold text-[#001935]" data-testid="admin-ambassador-active-count">Active {activeCount}</div>
        </div>
      </div>

      <div className="mt-6 grid gap-4">
        {ambassadors.map((ambassador) => {
          const timeline = buildTimeline(ambassador);
          return (
            <div className="rounded-[24px] border border-[#001935]/10 bg-white p-5" data-testid={`admin-ambassador-status-row-${ambassador.slug}`} key={ambassador.slug}>
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <p className="text-xl font-semibold text-[#001935]">{ambassador.name}</p>
                  <p className="mt-2 text-xs font-bold uppercase tracking-[0.18em] text-[#5e6c7b]">{ambassador.public_path}</p>
                </div>
                <span className={`rounded-full px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] ${statusToneMap[ambassador.status_label] || "bg-[#EEF2F6] text-[#42566f]"}`} data-testid={`admin-ambassador-status-pill-${ambassador.slug}`}>
                  {ambassador.status_label}
                </span>
              </div>

              <div className="mt-5 grid gap-3 md:grid-cols-3">
                <div className="rounded-[20px] bg-[#f8f5ef] px-4 py-4" data-testid={`admin-ambassador-first-login-${ambassador.slug}`}>
                  <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#8b6d16]">First login</p>
                  <p className="mt-2 text-sm font-semibold text-[#001935]">{formatStamp(ambassador.first_login_at)}</p>
                </div>
                <div className="rounded-[20px] bg-[#f8f5ef] px-4 py-4" data-testid={`admin-ambassador-claim-verified-${ambassador.slug}`}>
                  <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#8b6d16]">Claim verified</p>
                  <p className="mt-2 text-sm font-semibold text-[#001935]">{formatStamp(ambassador.claim_verified_at)}</p>
                </div>
                <div className="rounded-[20px] bg-[#f8f5ef] px-4 py-4" data-testid={`admin-ambassador-route-state-${ambassador.slug}`}>
                  <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#8b6d16]">Route state</p>
                  <p className="mt-2 text-sm font-semibold text-[#001935]">{ambassador.route_state}</p>
                </div>
              </div>

              {timeline.length ? (
                <div className="mt-5 rounded-[20px] bg-[#f8f5ef] px-4 py-4" data-testid={`admin-ambassador-invitation-timeline-${ambassador.slug}`}>
                  <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#8b6d16]">Invitation timeline</p>
                  <div className="mt-3 flex flex-wrap gap-3">
                    {timeline.map((item) => (
                      <div className="rounded-full border border-[#D4AF37]/20 bg-white px-4 py-2 text-xs font-semibold text-[#001935]" data-testid={item.testId} key={item.testId}>
                        {item.label}: {formatStamp(item.value)}
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};